import React from 'react';
import './tab-menu.css';
import PropTypes from 'prop-types';
import { IconButton } from '../icon-button';
import { goToScreen } from '../../actions/router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
    DEBATE_GAME_SCREEN,
    INQUIRY_GAME_SCREEN,
    MEETINGS_GAME_SCREEN,
    MESSAGES_GAME_SCREEN,
    QUESTIONS_GAME_SCREEN,
    PRESS_GAME_SCREEN,
    QUICKPLAY_SCREEN,
    VOTE_GAME_SCREEN,
} from '../../constants/routes';
import { Paragraph } from '../paragraph';

const TabMenu = props => {
    const {
        screen,
        currentDay,
        goToScreen,
        messagesNotifications,
        meetingsNotifications,
        shouldBeUninteractable,
        setActiveGame,
    } = props;

    const quickplayScreen = screen === QUICKPLAY_SCREEN;

    const tabMenuContainerClasses = classNames({
        'tab-menu__container': true,
        'tab-menu__container--quickplay': quickplayScreen,
    });

    const tabMenuClasses = classNames({
        'tab-menu': true,
        'tab-menu--quickplay': quickplayScreen,
    });

    const tabClasses = classNames({
        tab: true,
        'tab--quickplay': quickplayScreen,
    });

    return (
        <div
            className={tabMenuContainerClasses}
            aria-hidden={shouldBeUninteractable}
        >
            <nav className={tabMenuClasses}>
                <div className={tabClasses}>
                    <IconButton
                        onClick={() =>
                            quickplayScreen
                                ? setActiveGame('messages')
                                : goToScreen(MESSAGES_GAME_SCREEN)
                        }
                        iconName="messages"
                        type="main"
                        notifications={
                            !quickplayScreen ? messagesNotifications : null
                        }
                        isDisabled={
                            (!quickplayScreen && messagesNotifications < 1) ||
                            shouldBeUninteractable
                        }
                    />
                    <Paragraph withSpacing={false}>Messages</Paragraph>
                </div>
                <div className={tabClasses}>
                    <IconButton
                        onClick={() =>
                            quickplayScreen
                                ? setActiveGame('press')
                                : goToScreen(PRESS_GAME_SCREEN)
                        }
                        iconName="press"
                        type="main"
                        notifications={!quickplayScreen ? 1 : null}
                        isDisabled={shouldBeUninteractable}
                    />
                    <Paragraph withSpacing={false}>Press</Paragraph>
                </div>
                <div className={tabClasses}>
                    <IconButton
                        onClick={() =>
                            quickplayScreen
                                ? setActiveGame('meetings')
                                : goToScreen(MEETINGS_GAME_SCREEN)
                        }
                        iconName="meetings"
                        type="main"
                        notifications={
                            !quickplayScreen ? meetingsNotifications : null
                        }
                        isDisabled={
                            (!quickplayScreen && meetingsNotifications < 1) ||
                            shouldBeUninteractable
                        }
                        isLocked={!quickplayScreen && currentDay < 1}
                    />
                    <Paragraph withSpacing={false}>Meetings</Paragraph>
                </div>
                <div className={tabClasses}>
                    <IconButton
                        onClick={() =>
                            quickplayScreen
                                ? setActiveGame('debate')
                                : goToScreen(DEBATE_GAME_SCREEN)
                        }
                        iconName="debate"
                        type="main"
                        notifications={!quickplayScreen ? 1 : null}
                        isLocked={!quickplayScreen && currentDay < 2}
                        isDisabled={shouldBeUninteractable}
                    />
                    <Paragraph withSpacing={false}>Debate</Paragraph>
                </div>
                <div className={tabClasses}>
                    <IconButton
                        onClick={() =>
                            quickplayScreen
                                ? setActiveGame('inquiry')
                                : goToScreen(INQUIRY_GAME_SCREEN)
                        }
                        iconName="inquiry"
                        type="main"
                        notifications={!quickplayScreen ? 1 : null}
                        isLocked={!quickplayScreen && currentDay < 3}
                        isDisabled={shouldBeUninteractable}
                    />
                    <Paragraph withSpacing={false}>Inquiry</Paragraph>
                </div>
                {screen === QUICKPLAY_SCREEN && (
                    <>
                        <div className={tabClasses}>
                            <IconButton
                                onClick={() =>
                                    quickplayScreen
                                        ? setActiveGame('questions')
                                        : goToScreen(QUESTIONS_GAME_SCREEN)
                                }
                                iconName="questions"
                                type="main"
                            />
                            <Paragraph withSpacing={false}>Questions</Paragraph>
                        </div>
                        <div className={tabClasses}>
                            <IconButton
                                onClick={() =>
                                    quickplayScreen
                                        ? setActiveGame('vote')
                                        : goToScreen(VOTE_GAME_SCREEN)
                                }
                                iconName="vote"
                                type="main"
                            />
                            <Paragraph withSpacing={false}>Vote</Paragraph>
                        </div>
                    </>
                )}
            </nav>
        </div>
    );
};

TabMenu.propTypes = {
    goToScreen: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => {
    return {
        goToScreen: route => {
            dispatch(goToScreen(route));
        },
    };
};

const connected = connect(null, mapDispatchToProps)(TabMenu);
export { connected as TabMenu };
